import React from 'react'
import ExcelUpload from '../../components/common/excel-upload/excel-upload'

const KanalTipi = () => {
    return (
        <div>
            <ExcelUpload
                requiredColumnsSase={["sase", "Kanal Tipi"]}
                process_type="CHANNEL_TYPE"
                ExcelName={"Kanal Tipi Hatalı Şaseler"}
                Title={"Kanal Tipi"}
                exampleData={[{
                    "sase": "VF3YEF6F0RMA03711",
                    "Kanal Tipi": "B2C"
                },
                {
                    "sase": "VF3YEF6F0RMA03711",
                    "Kanal Tipi": "B2B"
                },
                {
                    "sase": "VF3YEF6F0RMA03711",
                    "Kanal Tipi": "İPTAL"
                }]}
                role_name={"kanal_tipi_write"}
            />
        </div>
    )
}

export default KanalTipi